export class DataLayerTracker {
  static init() {
    window.dataLayer = window.dataLayer || []
  }

  static push(data) {
    if (!window || !data) {
      return
    }

    DataLayerTracker.init()
    window.dataLayer.push(data)
  }
}
